import { render, staticRenderFns } from "./serviceManageList.vue?vue&type=template&id=28d34397&scoped=true"
import script from "./serviceManageList.vue?vue&type=script&lang=js"
export * from "./serviceManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d34397",
  null
  
)

export default component.exports